import React, { useEffect, useCallback } from 'react'
import Layout from './components/Layout'
import Login from './pages/Login/Login'
import Router from './components/MainRouter'
import './styles/App.css'
// import "bootstrap/dist/css/bootstrap.min.css";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { connect } from 'react-redux'
import MessageHandler from './components/AlertMessage'
import {
    isSessionValid,
    handleSessionExpiry,
    updateLastActivity,
} from './Utils/sessionManager'

const SESSION_CHECK_INTERVAL = 60 * 1000 // Check every 1 minute

const App = ({ isAuth }) => {
    console.log('before app component render')

    // Check session validity
    const checkSession = useCallback(() => {
        if (localStorage.token) {
            const { valid, reason } = isSessionValid()
            if (!valid) {
                handleSessionExpiry(reason)
            }
        }
    }, [])

    // Handle user activity
    const handleActivity = useCallback(() => {
        if (localStorage.token) {
            updateLastActivity()
        }
    }, [])

    useEffect(() => {
        // Check session on mount
        checkSession()

        // Set up periodic session check
        const intervalId = setInterval(checkSession, SESSION_CHECK_INTERVAL)

        // Track user activity events
        const activityEvents = ['mousedown', 'keydown', 'touchstart', 'scroll']
        activityEvents.forEach((event) => {
            window.addEventListener(event, handleActivity)
        })

        // Cleanup
        return () => {
            clearInterval(intervalId)
            activityEvents.forEach((event) => {
                window.removeEventListener(event, handleActivity)
            })
        }
    }, [checkSession, handleActivity])

    return (
        <>
            {!localStorage.token ? (
                <Login />
            ) : (
                <>
                    <Layout>
                        <Router />
                    </Layout>
                </>
            )}

            <MessageHandler />
        </>
    )
}

const mapStateToProps = (props) => {
    const { GeneralReducer } = props
    const { isAuth } = GeneralReducer

    return { isAuth }
}

export default connect(mapStateToProps)(App)
